export default {
      id: "menu-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "app/svg/sprite.svg#menu",
      toString: function () {
        return this.url;
      }
    }